import { useState, useEffect, RefObject } from 'react';
import { useContainerDimensions } from './container-dimensions';

// These values are used to calculate the triggerOnPx value
// which is the point at which the header becomes sticky

// Hardcoded values are the same as in legacy code

// Minimum scroll distance to trigger sticky header
const MIN_STICKY_SCROLL = 150;
// Minimum scroll distance to trigger slide down header
const MIN_SLIDE_SCROLL = 200;
// Height of the progress bar
const PROGRESS_BAR_HEIGHT = 5;
// Height of the header when sticky and moving up
const HEADER_HEIGHT = 80 + PROGRESS_BAR_HEIGHT;

const useStickyScroll = (containerRef: RefObject<HTMLDivElement>) => {
  const getStickyScroll = (prev: typeof stickyScroll) => {
    let scrollY = typeof window !== 'undefined' ? window.scrollY : 0;

    const triggerOnPx = top;
    const isUp = prev.scroll < scrollY;
    let isSticky = scrollY >= triggerOnPx;
    const scrollPercent = getScrollPercent();
    const slideDown = checkSlideDown(prev, scrollY);

    if (isUp === false) {
      isSticky = scrollY >= triggerOnPx - HEADER_HEIGHT;
    }

    return {
      scroll: scrollY,
      isSticky,
      slideDown,
      height,
      isUp,
      triggerOnPx: top,
      scrollPercent,
    };
  };

  const checkSlideDown = (prev: typeof stickyScroll, scrollY: number) => {
    const parent = containerRef.current?.parentElement;
    const parentY = parent?.getBoundingClientRect()?.y || 0;

    if (prev.isUp) {
      return false;
    }
    if (scrollY <= MIN_SLIDE_SCROLL) {
      return false;
    }
    if (parentY > 0) {
      return false;
    }
    return true;
  };

  const getScrollPercent = () => {
    let scrollY = 0;
    let innerHeight = 0;
    if (typeof window !== 'undefined') {
      scrollY = window.scrollY;
      innerHeight = window.innerHeight;
    }
    let scrollTop = scrollY;
    let docHeight = document.body.offsetHeight;
    let winHeight = innerHeight;
    let scrollPercent = scrollTop / (docHeight - winHeight);
    let scrollPercentRounded = Math.round(scrollPercent * 100);
    return `${scrollPercentRounded}%`;
  };

  const { top, width, height } = useContainerDimensions(containerRef);
  const [stickyScroll, setStickyScroll] = useState({
    scroll: 0,
    isSticky: false,
    height,
    isUp: false,
    slideDown: false,
    triggerOnPx: top,
    scrollPercent: '0',
  });

  useEffect(() => {
    const handleScroll = () => {
      setStickyScroll(prev => getStickyScroll(prev));
    };

    let scrollTimeout = setTimeout(() => {
      if (containerRef.current) {
        setStickyScroll(prev => getStickyScroll(prev));
      }
    }, 100);

    if (typeof window !== 'undefined') {
      window.addEventListener('scroll', handleScroll);
    }

    return () => {
      clearTimeout(scrollTimeout);
      if (typeof window !== 'undefined') {
        window.removeEventListener('scroll', handleScroll);
      }
    };
  }, [containerRef]);

  return stickyScroll;
};

export default useStickyScroll;
